const assetTypeSelector = (state, prop, def, type) =>
	prop?.[type ?? state.assets.assetLibraryModalType] ?? def ?? null;
export const assetsSelector = (state) => assetTypeSelector(state, state.assets.assets, []);
export const assetsWithTypeSelector = (type) => (state) =>
	assetTypeSelector(state, state.assets.assets, [], type);
export const uploadedAssetSelector = (state) =>
	assetTypeSelector(state, state.assets.uploadedAsset);

export const assetsCurrentPageSelector = (state) =>
	assetTypeSelector(state, state.assets.assetsCurrentPage, 1);
export const assetsHasNextPageWithTypeSelector = (type) => (state) =>
	assetTypeSelector(state, state.assets.assetsHasNextPage, false, type);
export const assetsNextTsWithTypeSelector = (type) => (state) =>
	assetTypeSelector(state, state.assets.assetsNextTs, false, type);

export const assetsCurrentPageWithTypeSelector = (type) => (state) =>
	assetTypeSelector(state, state.assets.assetsCurrentPage, 1, type);

export const assetsListApiStageSelector = (state) =>
	assetTypeSelector(state, state.assets.assetsListApiStage);
export const assetsUploadApiStageSelector = (state) =>
	assetTypeSelector(state, state.assets.assetsUploadApiStage);
export const assetsDeleteApiStageSelector = (state) =>
	assetTypeSelector(state, state.assets.assetsDeleteApiStage);
export const isAssetLibraryModalOpenSelector = (state) => state.assets.isAssetLibraryModalOpen;
export const assetLibraryModalDetailsSelector = (state) => state.assets.assetLibraryModalDetails;
export const isTemplateModalOpenSelector = (state) => state.assets.isTemplateModalOpen;
export const isTemplateAssetSelectedSelector = (state) => state.assets.isTemplateAssetSelected;
export const assetLibraryModalTypeSelector = (state) => state.assets.assetLibraryModalType;
export const assetsMapSelector = (state) => state.assets?.assetsMap;
